/* eslint-disable no-undef */
export default {
	name: "password-update-modal",
	data() {
		return {
			idForModal: null,
			password: {
				value: null,
				hasError: false,
				errorMessage: null
			},
			currentPassword: {
				value: null,
				hasError: false,
				errorMessage: null
			},
			confirmPassword: {
				value: null,
				hasError: false,
				errorMessage: null
			},
			showSuccessMessage: false,
			successMessage: null,
			showErrorMessage: false,
			errorMessage: null,
			loading: false,
			passwordUpdateModalId: "passwordUpdateModal"
		};
	},
	methods: {
		onModalCloseClick(){
			$("#" + this.passwordUpdateModalId).modal("hide");
		},
		passwordUpdate(){
			this.loading = true;
			let request = {
				password: this.password.value,
				confirmPassword: this.confirmPassword.value,
				oldPassword: this.currentPassword.value
			};
			securityService.updatePassword(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						if(successResponse.data.updatePasswordValidationResponse.valuesAreValid){
							this.showSuccessMessage = true;
							this.successMessage = "Password updated successfully. You will be redirected to the login page";
						}
						else{
							this.password.hasError = successResponse.data.updatePasswordValidationResponse.passwordValidationResponse.hasError;
							this.password.errorMessage = successResponse.data.updatePasswordValidationResponse.passwordValidationResponse.message;
							
							this.confirmPassword.hasError = successResponse.data.updatePasswordValidationResponse.confirmPasswordValidationResponse.hasError;
							this.confirmPassword.errorMessage = successResponse.data.updatePasswordValidationResponse.confirmPasswordValidationResponse.message;
							
							this.currentPassword.hasError = successResponse.data.updatePasswordValidationResponse.oldPasswordValidationResponse.hasError;
							this.currentPassword.errorMessage = successResponse.data.updatePasswordValidationResponse.oldPasswordValidationResponse.message;
						}
					}
					this.loading = false;
				},
				errorResponse => {
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
					this.loading = false;
				}
			);
		},
		onOkClick(){
			if(this.showSuccessMessage){
				window.location.replace("/Account/Login");
			}
		}
	},
	computed: {
        
	},
	mounted: function () {
	},
	watch: {
	}
};